//Slick
window.bars.listener.ready.push(function() {
	$('.slick--home').slick({
		infinite: true,
		autoplay: true,
		autoplaySpeed: 10000,
		slidesToShow: 1,
		centerMode: false,
		dots: true,
		arrows: false,
		slide:'.slide',
		initialSlide: 0,
		rows:0
	});

	$('.slick-slider--aktuelles').slick({
		infinite: false,
		autoplay: false,
		autoplaySpeed: 10000,
		slidesToShow: 5,
		centerMode: false,
		centerPadding: '0px',
		initialSlide: 0,
		arrows: true,
		dots: false,
		responsive: [
			{
				breakpoint: 769,
				settings: {
					slidesToShow: 3,
				}
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 1,
				}
			}
		]
	});

	$('.slick-slider--images').slick({
		infinite: true,
		autoplay: false,
		autoplaySpeed: 10000,
		slidesToShow: 3,
		centerMode: true,
		variableWidth: false,
		centerPadding: '0px',
		initialSlide: 0,
		arrows: true,
		dots: false,
		rows:0,
		responsive: [
			{
				breakpoint: 769,
				settings: {
					slidesToShow: 3,
					dots: true
				}
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 1,
					dots: true
				}
			}
		]
	});
	
	
	$('.slick-slider--gallery').slick({
		infinite: true,
		autoplay: true,
		autoplaySpeed: 5000,
		slidesToShow: 1,
		variableWidth: false,
		initialSlide: 0,
		slide:'.slide',
		fade: true,
		//adaptiveHeight:true,
		arrows: false,
		dots: false,
		rows:0,
		
	});
	
	

	$('.slick-slider--tablets').slick({
		infinite: true,
		autoplay: true,
		autoplaySpeed: 10000,
		slidesToShow: 1,
		centerMode: true,
		centerPadding: '180px',
		variableWidth: false,
		initialSlide: 0,
		draggable: true,
		arrows: false,
		dots: false,
		responsive: [
			{
				breakpoint: 1140,
				settings: {
					centerPadding: '80px',
				}
			},
			{
				breakpoint: 768,
				settings: {
					centerPadding: '40px',
				}
			}
		]
	});

	$('.slick-slider--mood').slick({
		infinite: true,
		autoplay: true,
		autoplaySpeed: 10000,
		slidesToShow: 1,
		variableWidth: false,
		initialSlide: 0,
		draggable: true,
		arrows: false,
		dots: false,
		fade: true
	});
});

window.bars.listener.ready.push(function(){
	//Anker root bugfix
	var stageHome = $(".stage--home");
	if(stageHome && stageHome.length > 0) {
		$(".nav-toggle__item a, .bar--footer a").each(function(){
			var link = $(this);
			var href = link.attr("href");
			if(href.startsWith("/#")) {
				link.attr("href",href.substring(1));
			}
		});
	}
});

